import React, { useState } from "react";
import classes from "./CustomRadioButton.module.scss";
import { useTranslation } from "react-i18next";

const CustomRadioButton = ({ values, name, handleChangeRadio }) => {
  const { i18n } = useTranslation();
  const [val, setVal] = useState("");

  const onChangeValue = (e) => {
    setVal(e.target.value);
    handleChangeRadio(e);
  };

  return (
    <div className={classes.root}>
      {values.map((value, index) => (
        <label
          className={classes.containerInput}
          style={{
            paddingLeft: i18n.language === "fa" ? "35px" : "35px",
            paddingRight: i18n.language === "fa" ? "0" : "35px",
          }}
        >
          <p>{value.label}</p>
          <input
            type="radio"
            checked={value.value === val}
            name={name}
            value={value.value}
            onChange={(e) => onChangeValue(e)}
          />
          <span className={classes.checkmark}></span>
        </label>
      ))}
    </div>
  );
};

export default CustomRadioButton;
